import { UploadFile } from "antd";

interface IContactUser {
    id: number;
    name: string;
}

export interface IContact {
    id: number;
    title: string;
    message: string;
    status: ContactStatus;
    files: {
        file: string;
    }[];
    subject_contact_id: number;
    subject_contact?: ISubjectContact;
    messages?: IMessageContact[];
    app_user_viewed?: boolean;
    app_user_viewed_at?: string | null;
    panel_user_viewed?: boolean;
    panel_user_id?: number | null;
    panel_user?: IContactUser | null;
    app_user?: IContactUser | undefined;
    created_at: string;
    updated_at: string;
}

export enum ContactStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED"
}

export const STATUS_COLORS = {
    OPEN: '#9CA3AF',
    CLOSED: '#10B981',
};

export interface ISubjectContact {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
}

export interface IFile {
    uri?: string;
    name?: string | null;
    type?: string | null;
}

export interface IContactInputs {
    title: string;
    message: string;
    subject_contact_id: number;
    files: IFile[];
}


export interface IMessageContact {
    id: number;
    message: string;
    files: {
        file: string;
    }[];
    panel_user_id?: number | null;
    app_user_id?: number | null;
    viewed?: boolean;
    viewed_at?: string | null;
    panel_user?: {
        id: number;
        name: string;
    } | null;
    app_user?: {
        id: number;
        name: string;
    } | null;
    created_at: string;
    updated_at: string;
}

export interface IMessageUser {
    id: number,
    name: string,
    cpf: string,
    read: boolean,
}

export interface IContactInputs {
    id: number,
    status: ContactStatus,
    created_at: string,
    updated_at: string
}

export interface IMessageContactInputs {
    message: string,
    files: UploadFile[] | null,
    county_id?: number,
    contact_id?: number
}

export interface IChangeFileProps {
    onChangeHookForm: (event: any) => void,
    file: UploadFile,
}